import { IComponentOptions } from "angular";
import { AmendmentDetailViewController } from "./controller";

export const vsComponentName = "contractAmendmentDetailComponent";

export const amendmentDetailComponentOptions: IComponentOptions = {
  controller: AmendmentDetailViewController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    amendment: "<",
  },
};
